import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import { useNavigate } from "react-router-dom";
import { useAuthHandling } from "../useAuthhandling";
import Toastmodal from "../Toastmodal";
import Cookies from "js-cookie";
import { FiPlusCircle } from 'react-icons/fi';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import Allimageselect from "../Blog/Allimageselect";
import Allimagestyle from "../Blog/Allimage_style";
import Select from 'react-select';
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.setLocationType("ROOFTOP");



function Propertyadd() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();
  let navigate = useNavigate();

  const [property, setProperty] = useState({
    title: "",
    file: [],
    status: '',
    fileType: ''
  });

  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);
  const [selectedAminities, setSelectedAminities] = useState([]);
  const [aminity, setAminity] = useState([]);
  const [newAminity, setNewAminity] = useState('');
  const [showInput, setShowInput] = useState(false);
  const [location, setLocation] = useState({
    name: "Kochi, Kerala, India",
    lat: 9.9312,
    long: 76.2673,
  });

  const [selectedImageId, setSelectedImageId] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);

  const [loc, setLoc] = useState("Kochi, Kerala, India");
  const [propertytype, setProprtytype] = useState([]);
  const [cust, setCust] = useState([]);
  const [useroption,setUseroption]=useState([]);
  const [selecteduser,setSelecteduser]=useState([]);

  const [selectedtype, setselectedType] = useState('');
  const [property_option, setPropertyoption] = useState('');

  const [addressstring, setaddressstring] = useState(
    "W7M9+9C Kochi, Kerala, India"
  );
  const [subloc,setSubloc]=useState('Kochi');
  const [city,setCity]=useState('Kochi');
  const [country,setCountry]=useState('India');
  const [district,setDistrict]=useState('Ernakulam');
  const [state,setState]=useState('Kerala');



  const [formerror, setError] = useState({});

  let name, value;

  const handleInputs = (e) => {
    name = e.target.name;
    value = e.target.value;
    setProperty({ ...property, [name]: value });
  }
  const handleInputstype = (e, slug) => {
    name = e.target.name;
    value = e.target.value;
    setProperty({ ...property, [name]: value });
    setselectedType(slug);
  }

  const onFileChange = (e) => {
    let name = e.target.name;
    setProperty({ ...property, [name]: e.target.files });
  };

  const handleCheckboxChange = (value) => {
    if (value === 'Others') {
      setShowInput(!showInput);
      if (selectedAminities.includes(value)) {
        setSelectedAminities(selectedAminities.filter((item) => item !== value));
      } else {
        setSelectedAminities([...selectedAminities, value]);
      }
    } else {
      if (selectedAminities.includes(value)) {
        setSelectedAminities(selectedAminities.filter((item) => item !== value));
      } else {
        setSelectedAminities([...selectedAminities, value]);
      }
    }
  };
  const handleAddAminity = () => {
    if (newAminity) {
      const am = {  title: newAminity }
      setSelectedAminities([...selectedAminities, newAminity]);
      setAminity([...aminity, am])
      setNewAminity('');
    }
  };


  const handleChange = async (value) => {
    setLocation({
      name: value,
      lat: location.lat,
      long: location.long,
    });
    setLoc(value);
  };

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    const addressComponents = results[0].address_components;
    let subLocation = "";
      let city = "";
      let country = "";
      let district = "";
      let state = "";
      // Loop through the address components to extract the required info
      addressComponents.forEach((component) => {
        const types = component.types;

        // Extract sub-location (neighborhood or administrative area)
        if (types.includes("sublocality") || types.includes("neighborhood")) {
          subLocation = component.long_name;
        }

        // if (types.includes("administrative_area_level_2") || (!types.includes("sublocality") && types.includes("administrative_area_level_3")) ) {
        //   if (types.includes("administrative_area_level_3")){
        //   district = component.long_name;
        //   }
        // }
        // else if (types.includes("sublocality") && types.includes("locality") ) {
        //   if (types.includes("locality")){

        //   district = component.long_name;
        //   }
        // }

        // if (types.includes("administrative_area_level_2") || types.includes("administrative_area_level_3")) {
        //   district = component.long_name;
        // } else if (types.includes("sublocality") || types.includes("locality")) {
        //   district = component.long_name;
        // }
      //   if (
      //     types.includes("administrative_area_level_2") || types.includes("sublocality")) {
      //       district = component.long_name;

      //     }
      //  else if (types.includes("sublocality") && types.includes("locality")) {

      //      if(types.includes("locality")) {
      //       district = component.long_name;
      //     }
      //   }
      //   else if(types.includes("administrative_area_level_3")) {
      //       district = component.long_name;
      //     }
        
      if (types.includes("administrative_area_level_2") || types.includes("locality") || types.includes("administrative_area_level_3") ) {
          district = component.long_name;
          
        }
        // Extract city (locality)
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }

        // Extract country
        if (types.includes("country")) {
          country = component.long_name;
        }

      })
      
      // if(subLocation){
      //   setSubloc(subLocation);
      // }
      // else if(city){
      //   setSubloc(city);
      // }
      // else if(district){
      //   setSubloc(district);
      // }
      // else if(state){
      //   setSubloc(state);
      // }
      // else{
      //   setSubloc(country);
      // }


      // if(city){
      // setCity(city);
      // }
      // else if(district){
      //   setCity(district);
      // }
      // else if(state){
      //   setCity(state);
      // }
      // else{
      //   setCity(country);
      // }

      // if(district){
      //   setDistrict(district);
      //   }
      //   else if(state){
      //     setDistrict(state);
      //   }
      //   else{
      //     setDistrict(country);
      //   }
   
      //   if(state){
      //     setState(state);
      //     }
      //     else{
      //       setState(country);
      //     }
     
      // setCountry(country);

      setSubloc(subLocation || city || district || state || country);
      setCity(city || district || state || country);
      setDistrict(district || state || country);
      setState(state || country);
      setCountry(country);

    Geocode.fromLatLng(latLng.lat, latLng.lng).then((response) => {
      const address = response.results[0].formatted_address;
      setaddressstring(address);
    });
    setLocation({
      name: value,
      lat: latLng.lat,
      long: latLng.lng,
    });
    setLoc(value);
  };
  const PostData = async (e) => {
    e.preventDefault();
    let formvalid = true;
    const errors = {};

    if(!property_option){
      errors.property_option = "Property option is required!";
      formvalid = false;

    }
    if (!property.property_ad_title) {
      errors.property_ad_title = "Property title is required!";
      formvalid = false;
    }
    if (!property.property_name) {
      errors.property_name = "Property name is required!";
      formvalid = false;
    }
    if (!property.description) {
      errors.description = "Property description is required!";
      formvalid = false;
    }
    
    if (!selecteduser?.value) {
      errors.contact_person = "Contact person is required!";
      formvalid = false;
    }
    

    if (!property.property_type) {
      errors.property_type = "Property type is required!";
      formvalid = false;
    }
    if (!property.listed_by) {
      errors.listed_by = "Listed by is required!";
      formvalid = false;
    }
    if (!property.metaTitle) {
      errors.metaTitle = "Meta title is required!";
      formvalid = false;
    }
   
    if (!property.status) {
      errors.status = "status is required!";
      formvalid = false;
    }

    if (!property.canonicalURL) {
      errors.canonicalURL = "Canonical URL is required!";
      formvalid = false;
    }

    if (selectedImageId.length===0) {
      errors.file = "File is required!";
      formvalid=false;
   } 
    
    //  if (property.file.length===0) {
      
    //      errors.file = "File is required!";
    //      formvalid=false;
       
    //  } 
    //  else{
    //      for (var i = 0; i < property.file.length; i++) {
    //       if (
    //         property.file[i].type == "image/jpeg" ||
    //         property.file[i].type == "image/jpg" ||
    //         property.file[i].type == "image/png" ||
    //         property.file[i].type == "image/webp"
            
    //       ) {
           
    //         console.log();
  
    //       } else {
    //         errors.image = "Only support jpg, jpeg, png, webp image!";
    //         formvalid=false;

    //       }
    //     }


    //  }


     if(selectedtype==='house' ||  selectedtype==='apartment' ||selectedtype==='villas'){
        if (!property.bhk) {
          errors.bhk = "Bed room is required!";
          formvalid = false;
        }
        if (!property.bathrooms) {
          errors.bathrooms = "Bath room is required!";
          formvalid = false;
        }
        // if (!property.balcony) {
        //   errors.balcony = "This field is required!";
        //   formvalid = false;
        // }
        if (!property.build_up_area) {
          errors.build_up_area = "This field is required!";
          formvalid = false;
        }
        if (!property.carpet_area) {
          errors.carpet_area = "This field is required!";
          formvalid = false;
        }
        if (!property.furnished) {
          errors.furnished = "This field is required!";
          formvalid = false;
        }
        // if (!property.no_of_floors) {
        //   errors.no_of_floors = "This field is required!";
        //   formvalid = false;
        // }
        // if (!property.garage) {
        //   errors.garage = "This field is required!";
        //   formvalid = false;
        // }

       

        // if (!property.road_width) {
        //   errors.road_width = "This field is required!";
        //   formvalid = false;
        // }
        if (!property.price) {
          errors.price = "This field is required!";
          formvalid = false;
        }
    }
    if(selectedtype==='house' ||  selectedtype==='villas'){
        if (!property.plot_area) {
          errors.plot_area = "This field is required!";
          formvalid = false;
        } 
     }
    if(selectedtype==='apartment' ){
        if (!property.type) {
          errors.type = "This field is required!";
          formvalid = false;
        }
        if (property.no_of_floors) {
          if (!property.floor_number) {
            errors.floor_number = "This field is required!";
            formvalid = false;
          }
        }
        // if (!property.floor_number) {
        //   errors.floor_number = "This field is required!";
        //   formvalid = false;
        // }
     
     }

     if(selectedtype==='plots' ){
        if (!property.plot_area) {
          errors.plot_area = "This field is required!";
          formvalid = false;
        }
        if (!property.length) {
          errors.length = "This field is required!";
          formvalid = false;
        }
        if (!property.breadth) {
          errors.breadth = "This field is required!";
          formvalid = false;
        }
        // if (!property.road_width) {
        //   errors.road_width = "This field is required!";
        //   formvalid = false;
        // }
        if (!property.price) {
          errors.price = "This field is required!";
          formvalid = false;
        }

     }

     if(selectedtype==='office-space' ){
        if (!property.build_up_area) {
          errors.build_up_area = "This field is required!";
          formvalid = false;
        }
        if (!property.carpet_area) {
          errors.carpet_area = "This field is required!";
          formvalid = false;
        }
        if (!property.furnished) {
          errors.furnished = "This field is required!";
          formvalid = false;
        }
        if (property.no_of_floors) {
          if (!property.floor_number) {
            errors.floor_number = "This field is required!";
            formvalid = false;
          }
        }

        // if (!property.no_of_floors) {
        //   errors.no_of_floors = "This field is required!";
        //   formvalid = false;
        // }
        // if (!property.floor_number) {
        //   errors.floor_number = "This field is required!";
        //   formvalid = false;
        // }

        if (property.no_of_floors) {
          if (!property.floor_number) {
            errors.floor_number = "This field is required!";
            formvalid = false;
          }
        }
      
        // if (!property.garage) {
        //   errors.garage = "This field is required!";
        //   formvalid = false;
        // }
        if (!property.price) {
          errors.price = "This field is required!";
          formvalid = false;
        }
      
   
     }

     if(property_option==='rent' && selectedtype!=='plots'){
      if (!property.maintenanceCharge) {
        errors.maintenanceCharge = "This field is required!";
        formvalid = false;
      }
      
     }

    setError(errors);
    if (formvalid === true) {
      // const formData = new FormData();
      // formData.append("property_name", property.property_name);
      // formData.append("property_ad_title", property.property_ad_title);
      // formData.append("description", property.description);
      // formData.append("contact_person", property.contact_person);
      // formData.append("property_type", property.property_type);
      // if(property.yearOfConstruction){
      // formData.append("year_of_construction", Number(property.yearOfConstruction));
      // }
      // if(property.listed_by){
      //   formData.append("listed_by", property.listed_by);
      // }
      // if(property.condition){
      //   formData.append("condition", property.condition);
      // }
      // formData.append("property_location", location.name);
      // formData.append("google_address_string", addressstring);
      // formData.append("property_city", city);
      // formData.append("property_district", district);
      // formData.append("property_state", state);
      // formData.append("property_country", country);
      // formData.append("property_sub_location", subloc);
      // formData.append("longitude", location.long);
      // formData.append("latitude", location.lat);
      // for(var i=0;i<property.file.length;i++){
      //   formData.append("files", property.file[i]);
      // }
      // formData.append("status", property.status);
      // formData.append("meta_title", property.metaTitle);
      // formData.append("meta_description", property.metaDescription);
      // formData.append("canonicalURL", property.canonicalURL);

      // if(selectedtype==='house' || selectedtype==='apartment' || selectedtype==='villas'){
      //   formData.append("bedrooms", property.bhk);
      //   formData.append("bathrooms", Number(property.bathrooms));
      //   formData.append("balcony", Number(property.balcony));
      //   formData.append("build_up_area", Number(property.build_up_area));
      //   formData.append("carpet_area", Number(property.carpet_area));
      //   formData.append("furnished", property.furnished);
      //   formData.append("no_of_floors", Number(property.no_of_floors));
      //   formData.append("garage", Number(property.garage));
      //   formData.append("road_width", Number(property.road_width));
      //   formData.append("price", Number(property.price));
      //   // formData.append("plot_area", Number(property.plot_area));

      // }

      // if(selectedtype==='apartment'){
      //   formData.append("type", property.type);
      //   formData.append("floor_number", Number(property.floor_number));
      //  for(var i=0;i<selectedAminities.length;i++){
      //   formData.append(`amenities[${i}]`, selectedAminities[i]);
      //  }
      // }
      // if(selectedtype==='house' ||  selectedtype==='villas'){
      //   formData.append("plot_area", Number(property.plot_area));
      // }
      // if(selectedtype==='plots' ){
      //   formData.append("plot_area", Number(property.plot_area));
      //   formData.append("length", Number(property.length));
      //   formData.append("breadth", Number(property.breadth));
      //   formData.append("road_width", Number(property.road_width));
      //   formData.append("price", Number(property.price));
      // }
      // if(selectedtype==='villas'){
       
      //  for(var i=0;i<selectedAminities.length;i++){
      //   formData.append(`amenities[${i}]`, selectedAminities[i]);
      //  }
      // }
      // if(selectedtype==='office-space' ){
      //   formData.append("build_up_area", Number(property.build_up_area));
      //   formData.append("carpet_area", Number(property.carpet_area));
      //   formData.append("furnished", property.furnished);
      //   formData.append("no_of_floors", Number(property.no_of_floors));
      //   formData.append("floor_number", Number(property.floor_number));
      //   formData.append("garage", Number(property.garage));
      //   formData.append("price", Number(property.price));
      // }
      // if(property_option==='rent' && selectedtype!=='plots'){
      //   formData.append("maintenanceCharge", Number(property.maintenanceCharge));

      // }
      

      const data = {
        property_name: property.property_name,
        property_ad_title: property.property_ad_title,
        description: property.description,
        contact_person: selecteduser?.value,
        property_type: property.property_type,
        year_of_construction: property.yearOfConstruction ? Number(property.yearOfConstruction) : null,
        listed_by: property.listed_by || null,
        condition: property.condition || null,
        property_location: location.name,
        google_address_string: addressstring,
        property_city: city,
        property_district: district,
        property_state: state,
        property_country: country,
        property_sub_location: subloc,
        longitude: location.long,
        latitude: location.lat,
        property_images: selectedImageId.map((img) => img.id),
        status: property.status,
        meta_title: property.metaTitle,
        meta_description: property.metaDescription,
        canonicalURL: property.canonicalURL,
      };
      
      // Extend `data` conditionally based on `selectedtype`
      if (selectedtype === 'house' || selectedtype === 'apartment' || selectedtype === 'villas') {
        Object.assign(data, {
          bedrooms: property.bhk,
          bathrooms: Number(property.bathrooms),
          balcony: Number(property.balcony),
          build_up_area: Number(property.build_up_area),
          carpet_area: Number(property.carpet_area),
          furnished: property.furnished,
          no_of_floors: Number(property.no_of_floors),
          garage: Number(property.garage),
          road_width: Number(property.road_width),
          price: Number(property.price),
        });
      }
      
      if (selectedtype === 'apartment') {
        data.type = property.type;
        data.floor_number = Number(property.floor_number);
        data.amenities = selectedAminities;
      }
      
      if (selectedtype === 'house' || selectedtype === 'villas') {
        data.plot_area = Number(property.plot_area);
        data.amenities = selectedAminities;
      }
      
      if (selectedtype === 'plots') {
        Object.assign(data, {
          plot_area: Number(property.plot_area),
          length: Number(property.length),
          breadth: Number(property.breadth),
          road_width: Number(property.road_width),
          price: Number(property.price),
        });
      }
      
      if (selectedtype === 'office-space') {
        Object.assign(data, {
          build_up_area: Number(property.build_up_area),
          carpet_area: Number(property.carpet_area),
          furnished: property.furnished,
          no_of_floors: Number(property.no_of_floors),
          floor_number: Number(property.floor_number),
          garage: Number(property.garage),
          price: Number(property.price),
        });
      }
      
      if (property_option === 'rent' && selectedtype !== 'plots') {
        data.maintenanceCharge = Number(property.maintenanceCharge);
      }

      let URL;
      if(property_option==='rent'){
        URL='/api/v1/crm/rent/create';
      }
      else{
        URL='/api/v1/crm/property/create';
      }
      
      axios
        .post(`${Config.apiurl}${URL}`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }).then((res) => {
          if (res.status === 200) {
            setToastmodal(true);
            setToastmessage("Sucessfully added Property ");
            setToasttype("success");
            setToastlarge(false);
            setTimeout(() => navigate("/dashboard"), 3000);
          }
          else if (res.status === 401) {
          
            handleUnauthorized();
            PostData();
          }
          else {
            setToastmodal(true);
            setToastmessage("Something went wrong!");
            setToasttype("error");
            setToastlarge(false);
          }
        });
    }
  };

  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/property-types/get-property-types`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const data = await res.json();
    if (res.status === 200 ) {
     
      setProprtytype(data.data);
    }
    else if (res.status === 401) {
      handleUnauthorized();
      getinfo();
    }
  };

  const getcust = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/property/contact-person-dropdown`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );

    if (res.status === 200) {
      const data1 = await res.json();
      const data = data1.data;
      setCust(data);
    }
    else if (res.status === 401) {
      handleUnauthorized();
      getcust();
    }
    else {
      console.log("error!");
    }
  };

  useEffect(() => {
    getinfo();
    getcust();
  }, []);

  const getinfo1 = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/amenities/get-amenity`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200) {
      const data = await res.json();

      setAminity(data.data);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo1();
    }
    else {
      alert("error");

    }
  };
  useEffect(() => {
    getinfo1();
  }, []);

  useEffect(()=>{
    const options = cust.map(item => ({ value: item?._id, label: item?.name }));
    setUseroption(options);
  },[cust])
  
  return (
    <div>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Property</h4>
                      <p className="card-description">Add New Property </p>
                      <form className="forms-sample" onSubmit={PostData}>
                        <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Select property option  <span style={{ color: "red" }}>*</span></label>
                              <select className="form-select" name="property_option"
                                value={property_option}
                                onChange={(e)=>setPropertyoption(e.target.value)}>
                                <option>
                                  Select..
                                </option>
                                <option value="sell">
                                  Sell
                                </option>
                                <option value="rent">
                                  Rent
                                </option>
                                </select>
                              <label style={{ color: "red" }}>{formerror.property_option}</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Property Ad Title <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="text"
                                placeholder="Property Ad Title"
                                className="form-control"
                                id="exampleInputUsername1"

                                name="property_ad_title"
                                value={property.property_ad_title}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.property_ad_title}</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Property Name <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Property Name"
                                name="property_name"
                                value={property.property_name}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.property_name}</label>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Description <span style={{ color: "red" }}>*</span></label>
                              <textarea
                                rows="4"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Description"
                                name="description"
                                value={property.description}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.description}</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Contact Person <span style={{ color: "red" }}>*</span></label>
                              {/* <select className="form-select" name="contact_person"
                                value={property.contact_person}
                                onChange={handleInputs}>
                                <option>
                                  Select..
                                </option>
                                {cust.map((cu, i) => {
                                  return (
                                    <option value={cu._id}>{cu.name}</option>
                                  )
                                })}
                              </select> */}

                          <Select 
                            options={useroption}
                            isSearchable={true}
                            value={selecteduser}
                            className="my-select"
                            onChange={setSelecteduser}
                            // placeholder="Select the number of bedrooms"
                            />
                              <label style={{ color: "red" }}>{formerror.contact_person}</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Property Type <span style={{ color: "red" }}>*</span></label>
                              <select className="form-select" name="property_type"
                                value={property.property_type}
                                onChange={(e) => handleInputstype(e, e.target.selectedOptions[0].getAttribute('data-slug'))}>
                                <option>
                                  Select..
                                </option>
                                {propertytype.map((pro, i) => {
                                  return (
                                    <option value={pro._id} data-slug={pro.propertyTypeSlug}>{pro.propertyType}</option>
                                  )
                                })}


                              </select>

                              <label style={{ color: "red" }}>{formerror.property_type}</label>
                            </div>
                          </div>
                          {selectedtype === 'apartment' ?
                            <>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Type <span style={{ color: "red" }}>*</span></label>
                                  <select className="form-select" name="type"
                                    value={property.type}
                                    onChange={handleInputs}>
                                    <option>
                                      Select..
                                    </option>
                                    <option value="flat">Flat</option>
                                    <option value="apartment">Apartment</option>


                                  </select>

                                  <label style={{ color: "red" }}>{formerror.type}</label>
                                </div>
                              </div>
                            </>
                            

                            : ""}

                          {selectedtype === 'house' || selectedtype === 'apartment' || selectedtype==='villas'  ?
                            <>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Bed Rooms <span style={{ color: "red" }}>*</span></label>
                                  <select className="form-select" name="bhk"
                                    value={property.bhk}
                                    onChange={handleInputs}>
                                    <option>
                                      Select..
                                    </option>
                                    <option value="1_BHK">1 Bhk</option>
                                    <option value="2_BHK">2 Bhk</option>
                                    <option value="3_BHK">3 Bhk</option>
                                    <option value="4_BHK">4 Bhk</option>
                                    <option value="4_PLUS_BHK">5+ Bhk</option>

                                  </select>

                                  <label style={{ color: "red" }}>{formerror.bhk}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Bathrooms <span style={{ color: "red" }}>*</span></label>
                                 

                            <select className="form-select" name="bathrooms"
                                    value={property.bathrooms}
                                    onChange={handleInputs}>
                                    <option>
                                      Select..
                                    </option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>
                                  </select>
                                  <label style={{ color: "red" }}>{formerror.bathrooms}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Balcony</label>
                                  <select className="form-select" name="balcony" value={property.balcony} onChange={handleInputs}>
                                    <option>Select..</option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>

                                  </select>
                                  <label style={{ color: "red" }}>{formerror.balcony}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Build Up Area <span style={{ color: "red" }}>*</span></label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Build Up Area"
                                    name="build_up_area"
                                    value={property.build_up_area}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.build_up_area}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Carpet Area <span style={{ color: "red" }}>*</span></label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Carpet Area"
                                    name="carpet_area"
                                    value={property.carpet_area}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.carpet_area}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Furnished <span style={{ color: "red" }}>*</span></label>
                                  <select className="form-select" name="furnished" value={property.furnished} onChange={handleInputs}>
                                    <option>Select..</option>
                                    <option value="Fully furnished">Fully Furnished</option>
                                    <option value="Semi furnished">Semi Furnished</option>
                                    <option value="Un furnished">Un Furnished</option>

                                  </select>
                                  <label style={{ color: "red" }}>{formerror.furnished}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Number of Floors</label>
                                  <input
                                    type="number" 
                                    onFocus={(e) =>
                                    e.target.addEventListener(
                                      "wheel",
                                      function (e) {
                                        e.preventDefault();
                                      },
                                      { passive: false }
                                    )
                                  }
                                    min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Number of Floors"
                                    name="no_of_floors"
                                    value={property.no_of_floors}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.no_of_floors}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Garage</label>
                                  <select className="form-select" name="garage" value={property.garage} onChange={handleInputs}>
                                    <option>Select..</option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>

                                  </select>
                                  <label style={{ color: "red" }}>{formerror.garage}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Road Width</label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Road Width"
                                    name="road_width"
                                    value={property.road_width}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.road_width}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Price <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Price"
                                name="price"
                                value={property.price}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.price}</label>
                            </div>
                          </div>
                            </>
                            : ""}

                          {selectedtype === 'house' || selectedtype==='villas' ?
                            <>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Plot Area <span style={{ color: "red" }}>*</span></label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Plot Area"
                                    name="plot_area"
                                    value={property.plot_area}
                                    onChange={handleInputs}
                                  />
                                  <label style={{ color: "red" }}>{formerror.plot_area}</label>
                                </div>
                              </div>
                            </>

                            : ''
                          }

                          {selectedtype==='apartment'?
                        <>
                          <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Floor number</label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                             
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Floor number"
                              name="floor_number"
                              value={property.floor_number}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.floor_number}</label>
                          </div>
                        </div>

                       
                          <div className="col-md-12">
                        <div className="amenities-section">
                        <h3>Amenities <span style={{ color: "red" }}>*</span></h3>
                        <div className="amenities-grid">
                            {aminity.map((ami,i)=>{
                                return(
                                    <label> {ami.title}<input type="checkbox" name="amenities" value={ami.title}  checked={selectedAminities.includes(ami.title)}  onChange={() => handleCheckboxChange(ami.title)}/></label>
                                )
                            })}
                            <label>Others<input type="checkbox" name="amenities" value='Others' checked={selectedAminities.includes('Others')}  onChange={() => handleCheckboxChange('Others')}/></label>

                        </div>
                        {showInput && (
                            <div className='amenities_input_section col-md-6'>
                                <input
                                    type="text"
                                    placeholder="Enter the amenities"
                                    className="amenities-input"
                                    value={newAminity}
                                    onChange={(e) => setNewAminity(e.target.value)}
                                />
                                <button type="button" className='amenities_btns' onClick={handleAddAminity}><FiPlusCircle /></button>
                            </div>
                            )}
                    </div>
                         </div>
                        
                        </>  
                        :""
                        }
                        {selectedtype==='plots'?
                      <>
                      
                      <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Plot Area <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Plot Area"
                              name="plot_area"
                              value={property.plot_area}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.plot_area}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Length <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Length"
                              name="length"
                              value={property.length}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.length}</label>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Breadth <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Breadth"
                              name="breadth"
                              value={property.breadth}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.breadth}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Road Width</label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Road Width"
                              name="road_width"
                              value={property.road_width}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.road_width}</label>
                          </div>
                        </div>
                        <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Price <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Price"
                                name="price"
                                value={property.price}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.price}</label>
                        </div>
                        
                      </>  
                      :""
                      }
                      {selectedtype==='villas' ?
                    <>
                    <div className="col-md-12">
<div className="amenities-section">
<h3>Amenities <span style={{ color: "red" }}>*</span></h3>
<div className="amenities-grid">
{aminity.map((ami,i)=>{
                                return(
                                    <label> {ami.title}<input type="checkbox" name="amenities" value={ami.title}  checked={selectedAminities.includes(ami.title)}  onChange={() => handleCheckboxChange(ami.title)}/></label>
                                )
                            })}
                            <label>Others<input type="checkbox" name="amenities" value='Others' checked={selectedAminities.includes('Others')}  onChange={() => handleCheckboxChange('Others')}/></label>

</div>
{showInput && (
    <div className='amenities_input_section col-md-6'>
        <input
            type="text"
            placeholder="Enter the amenities"
            className="amenities-input"
            value={newAminity}
            onChange={(e) => setNewAminity(e.target.value)}
        />
        <button type="button" className='amenities_btns' onClick={handleAddAminity}><FiPlusCircle /></button>
    </div>
    )}
</div>
 </div>
                    </>  
                    :""
                    }

                    {selectedtype==='office-space'?
                    
                  <>
                      <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Build Up Area <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Build Up Area"
                              name="build_up_area"
                              value={property.build_up_area}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.build_up_area}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Carpet Area <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Carpet Area"
                              name="carpet_area"
                              value={property.carpet_area}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.carpet_area}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Furnished <span style={{ color: "red" }}>*</span></label>
                            <select className="form-select" name="furnished" value={property.furnished} onChange={handleInputs}>
                              <option>Select..</option>
                              <option value="Fully furnished">Fully Furnished</option>
                              <option value="Semi furnished">Semi Furnished</option>
                              <option value="Un furnished">Un Furnished</option>

                            </select>
                            <label style={{ color: "red" }}>{formerror.furnished}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Number of Floors</label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Number of Floors"
                              name="no_of_floors"
                              value={property.no_of_floors}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.no_of_floors}</label>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Floor number</label>
                            <input
                              type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Floor number"
                              name="floor_number"
                              value={property.floor_number}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.floor_number}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Garage</label>
                            <select className="form-select" name="garage" value={property.garage} onChange={handleInputs}>
                              <option>Select..</option>
                              <option value={1}>1</option>
                              <option value={2}>2</option>
                              <option value={3}>3</option>
                              <option value={4}>4</option>
                              <option value={5}>5</option>
                              <option value={6}>6</option>

                            </select>
                            <label style={{ color: "red" }}>{formerror.garage}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Price <span style={{ color: "red" }}>*</span></label>
                            <input
                              type="number" 
                              onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
                          min={0}
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Price"
                              name="price"
                              value={property.price}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.price}</label>
                          </div>
                        </div>
                  
                  </>
                  :""
                  }

                    {property_option==='rent' && selectedtype!=='plots' ?
                    
                    <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername1">Maintenance Charges <span style={{ color: "red" }}>*</span></label>
                      <input
                        type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                        className="form-control"
                        id="exampleInputUsername1"
                        placeholder="Maintenanace Charge"
                        name="maintenanceCharge"
                        value={property.maintenanceCharge}
                        onChange={handleInputs}
                      />
                      <label style={{ color: "red" }}>{formerror.maintenanceCharge}</label>
                    </div>
                  </div>
                  :""
                  
                  }
                                      {selectedtype==='house' || selectedtype==='apartment' || selectedtype==='villas'?

                            <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Year of Construction</label>
                                  <input
                                    type="number" 
 onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
 min={0}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Year of construction"
                                    name="yearOfConstruction"
                                    value={property.yearOfConstruction}
                                    onChange={handleInputs}
                                  />
                                
                                </div>
                              </div>
                              :""}
                             
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Listed By <span style={{ color: "red" }}>*</span></label>
                            <select className="form-select" name="listed_by" value={property.listed_by} onChange={handleInputs}>
                              <option>Select..</option>
                              <option value="owner">Owner</option>
                              <option value="broker">Broker</option>

                            </select>
                            <label style={{ color: "red" }}>{formerror.listed_by}</label>
                          </div>
                        </div>
                        <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor="exampleInputUsername1">Condition</label>
                                  <textarea
                                 rows={3}
                                    className="form-control"
                                    id="exampleInputUsername1"
                                    placeholder="Condition"
                                    name="condition"
                                    value={property.condition}
                                    onChange={handleInputs}
                                  />
                                
                                </div>
                              </div>
                  
                        
                          {/* <div className="col-md-6">

                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Property State</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Property State"
                              name="property_state"
                              value={property.property_state}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.property_state}</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Property District</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Property District"
                              name="property_district"
                              value={property.property_district}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>{formerror.property_district}</label>
                          </div>
                        </div> */}



                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">
                              Location <span style={{ color: "red" }}>*</span>
                            </label>
                            <PlacesAutocomplete
                              value={location.name}
                              onChange={handleChange}
                              onSelect={handleSelect}
                              name="location"
                            >
                              {({
                                getInputProps,
                                suggestions,
                                getSuggestionItemProps,
                                loading,
                              }) => (
                                <div className="position-relative">
                                  <input
                                    className="form-control"
                                    {...getInputProps({
                                      placeholder: " Enter your location",
                                    })}
                                    required
                                  />

                                  <div className="autocomplete-dropdown-container">
                                    {loading ? <div>...Loading</div> : null}

                                    {suggestions.map((suggestion, key) => {
                                      const style = suggestion.active
                                        ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        }
                                        : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        };

                                      return (
                                        <div
                                          className="form-conterol"
                                          {...getSuggestionItemProps(suggestion, {
                                            style,
                                          })}
                                          key={key}
                                        >
                                          {suggestion.description}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>

                          </div>


                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Meta Title <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Meta Title"
                                name="metaTitle"
                                value={property.metaTitle}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.metaTitle}</label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Canonical URL <span style={{ color: "red" }}>*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Canonical URL"
                                name="canonicalURL"
                                value={property.canonicalURL}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.canonicalURL}</label>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Meta Description</label>
                              <input
                                type="text"
                                className="form-control"
                                id="exampleInputUsername1"
                                placeholder="Meta Description"
                                name="metaDescription"
                                value={property.metaDescription}
                                onChange={handleInputs}
                              />
                              <label style={{ color: "red" }}>{formerror.metaDescription}</label>
                            </div>
                          </div>
                          <div className="col-md-12">

                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Upload Images <span style={{ color: "red" }}>*</span></label>
                              <br></br>

                              <Allimagestyle selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>

                              {/* <input type="file" name="file" onChange={onFileChange} multiple accept="image/png, image/jpeg ,image/jpg,image/webp"/> */}
                              <div className='clearfix mb-2'></div>
                              {/* {property.fileUploadPath ?
                                <img src={property.fileUploadPath} style={{ width: "100px", height: "100px", marginTop: "10px" }} />
                                :
                                ""
                              } */}

                              <Allimageselect selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>

                              <label style={{ color: "red" }}>{formerror.file}</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">Status <span style={{ color: "red" }}>*</span></label>
                              <select className="form-select" name="status" value={property.status} onChange={handleInputs}>
                                <option>Select..</option>
                                <option value='Pending'>Pending</option>
                                <option value='Listed'>Listed</option>
                                <option value='Unlisted'>Un listed</option>

                              </select>
                              <label style={{ color: "red" }}>{formerror.status}</label>
                            </div>
                          </div>
                        </div>
                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
    </div>
  );
}


export default Propertyadd;
